import TableHeader from './TableHeader';
import { COLUMNS } from './HeaderColumns';

export default TableHeader;
export { COLUMNS };
